"use client";

import { type MotionValue, useMotionValue, useTransform } from "motion/react";
import type { ChartProjection } from "./chart-projection-context";
import type { ViewTransform } from "./iso-projection";

export function useProjectionProgress(
  projection: ChartProjection | null
): MotionValue<number> {
  const fallback = useMotionValue(0);
  return projection?.e ?? fallback;
}

export function useProjectedValue<T>(
  projection: ChartProjection | null,
  build: (view: ViewTransform) => T,
  fallback: T
): MotionValue<T> {
  const e = useProjectionProgress(projection);
  return useTransform(e, (v) => (projection ? build(projection.at(v)) : fallback));
}

export function useProjectedPath(
  projection: ChartProjection | null,
  build: (view: ViewTransform) => string
): MotionValue<string> {
  return useProjectedValue(projection, build, "");
}
